module.exports = "<app-topbar></app-topbar>\n<div class=\"fix-router-outlet\">\n  <div class=\"app-body\">\n    <!--<app-mainbar></app-mainbar>-->\n    <div class=\"main\">\n      <!--<app-statusbar></app-statusbar>-->\n      <div class=\"main-content\">\n          <router-outlet></router-outlet>\n      </div>\n      <app-footbar></app-footbar>\n    </div>\n  </div>\n</div>\n<app-action-button></app-action-button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/main-layout/main-layout.component.html
// module id = 1147
// module chunks = 0